"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const WaitListInput = (props) => {
    const { name = "listIds" } = props;
    const merchantId = (0, react_hook_form_1.useWatch)({ name: "merchantId" });
    return (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: "wait-list/list", multiple: true, fetchData: { merchantId } });
};
exports.WaitListInput = WaitListInput;
//# sourceMappingURL=index.js.map